import React from 'react';
import classes from "./style.module.scss";

const BulkFiltrationProduct = ({ productData }) => {
    return (
        <>
        <div className={`${classes.productCardWrapper} mb-4`}>
            <div className={`${classes.detailsWrapper}`}>
                <div className='flex items-center mb-3'>
                    <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20`}>
                        Technical Specifications
                    </div>
                </div>
                <div className={`${classes.infoWrapper}`}>
                    {productData?.technicalData?.map((info, index) => (
                        <div key={index} className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>{info.label}</div>
                            <div className={`${classes.infoValue} ${classes.highlight}`}>{info.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

        <div className={`${classes.productCardWrapper} mb-4`}>
            <div className={`${classes.detailsWrapper}`}>
                <div className='flex items-center mb-3'>
                    <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20`}>
                        Product Information
                    </div>
                </div>
                <div className={`${classes.infoWrapper} flex-col`}>
                    {productData?.bulkProd?.map((info, index) => (
                        <div key={index} className={`${classes.inforCategory} max-w-[500px]`}>
                            <div className={`${classes.infoLabel}`}>{info.label}</div>
                            <div className={`${classes.infoValue} ${classes.highlight}`}>{info.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </>
    );
};

export default BulkFiltrationProduct;
